<template>
  <div class="designated-student">
    <div class="name-input">
      标签名称：<el-input
        style="width: 200px"
        v-model="labelName"
        placeholder="请输入标签名称"
      ></el-input>
    </div>
    <div class="select-box">
      <div>
        <span>选择年级：</span>
        <el-select
          v-model="gradeId"
          clearable
          placeholder="请选择"
          @change="gradeChange"
        >
          <el-option
            v-for="item in schoolGradeData"
            :key="item.gradeId"
            :label="item.gradeName"
            :value="item.gradeId"
          >
          </el-option>
        </el-select>
      </div>
      <div v-show="gradeId !== ''">
        <span>选择班级：</span>
        <el-select
          v-model="classId"
          clearable
          placeholder="请选择"
          @change="classChange"
        >
          <el-option
            v-for="item in schoolClassData"
            :key="item.classId"
            :label="item.className"
            :value="item.classId"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-transfer
      style="display: flex; justify-content: center"
      v-model="selectStudentList"
      :data="studentList"
      :titles="['未选择', '已选择']"
    ></el-transfer>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="tagStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isSelectMode", "schoolGradeData"],
  data() {
    return {
      // 学生列表
      studentList: [],
      // 选择学生列表
      selectStudentList: [],
      // 标签名称
      labelName: "",
      // 学校班级数据
      schoolClassData: [],
      // 年级id
      gradeId: "",
      // 班级id
      classId: "",
    };
  },
  created() {
    // 初始化查询学生列表
    this.selectStudentListPC();
  },
  methods: {
    // 班级改变
    classChange(e) {
      // 清空学生列表
      this.studentList = [];
      // 查询学生列表
      this.selectStudentListPC();
    },
    // 年级改变
    gradeChange(e) {
      if (e !== "") {
        // 获取学校班级数据
        this.schoolClassData = this.schoolGradeData.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      }
      // 清空学生列表
      this.studentList = [];
      // 查询学生列表
      this.selectStudentListPC();
    },
    // 查询学生列表
    selectStudentListPC() {
      let data = {
        // 学校id
        schoolId: this.user.schoolId,
        // 年级id
        gradeId: this.gradeId,
        // 班级id
        classId: this.classId,
      };
      // 请求查询学生列表
      this.get(this.$url.selectStudentListPC, data).then((res) => {
        console.log("查询学生列表==>", res);
        // 判断是否查询成功
        if (res.code == 200 && res.total !== 0) {
          // 遍历查询结果
          res.rows.forEach((item) => {
            // 将查询结果添加到学生列表
            this.studentList.push({
              key: item.id,
              label: item.studentName,
            });
          });
        }
      });
    },
    // 选择标签学生成绩对比点击提交
    tagStudentSubmit() {
      if (this.labelName == "") return this.$message.warning("请输入标签名称");
      if (this.selectStudentList.length == 0)
        return this.$message.warning("请选择学生");
      let data = {
        labelName: this.labelName, //标签id
        schoolId: this.user.schoolId,
        studentIds: this.selectStudentList, //学生id数组
      };
      // 提交选择标签学生成绩对比
      this.$emit("tagStudentSelectSubmit", data);
    },
    // 返回选择方式
    back() {
      // 返回选择方式
      this.$emit("update:isSelectMode", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./designatedStudent.scss";
</style>